import React, { useEffect, useState } from "react";
import useWidth from "../../hooks/useWidth";
import ImageSlider from "../../components/elements/ImageSlider";
import axios from "axios";
import MobileHeader from "../../layout/MobileHeader";
import Hero from "../../assets/images/hero.png";
import Navbar from "../../layout/Navbar";
import cardImg from "../../assets/images/topLocationHeader.png";
import AccommodationCard from "../../components/cards/mobileView/AccommodationCard";
import OfferCard from "../../components/cards/OfferCard";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";

import headerImg from '../../assets/images/topLocationHeader.png'


const LocationDeatials = () => {
  const width = useWidth();
  const [images, setImages] = useState([]);

  useEffect(() => {
    imagesFrom();
  }, []);

  const imagesFrom = async () => {
    try {
      const response = await axios.get(
        "https://jsonplaceholder.typicode.com/photos?_limit=10"
      );
      console.log(response);

      setImages(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {width > 992 ? (
        <>
          <Navbar gradient={true} />
          <h1 className="text-center" style={{ marginTop: "300px" }}>
            This page available only in mobile
          </h1>
        </>
      ) : (
        <>
          <MobileHeader height="237px" himage={headerImg}>
            <MobileHeaderSearch placeholder="Top Locations"/>
            
          </MobileHeader>
          <div className=" mobile-top-space">
            <ImageSlider data={images} />
          </div>
          <section className="px-3 mt-3">
            <div className="d-flex justify-content-between">
              <div className="">
                <div className="top-heading fs-3">Shiva Temple</div>
                <div className="top-destinations-subHeading">Pokhra, Nepal</div>
              </div>
              <div className="text-warning me-2  d-flex">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
            </div>

            <p className="">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              Cupiditate delectus voluptatem quisquam earum deleniti. Quis
              temporibus porro perferendis harum ex amet alias id error
              consectetur ducimus, dolorum adipisci quas, sapiente magnam, quo
              repudiandae. Blanditiis repellat fugiat, impedit quae voluptatum
              esse? Sed, vel quam. Dignissimos perferendis, hic quo nostrum quas
              commodi architecto ea repellat quam totam omnis consectetur sed
              eveniet eos iusto odio officiis. Perferendis dicta pariatur
              repellendus, itaque fuga eligendi in eveniet veniam exercitationem
              accusamus ex aut sed praesentium ab hic officiis veritatis iure.
              Officia quod adipisci, reiciendis pariatur ipsa molestiae. Nobis
              atque corporis placeat ipsam quibusdam temporibus dicta voluptate.
            </p>

            {/* near by attraction */}
            <div className="">
              <div className="top-heading">Near by Attractions</div>
              <div className="d-flex  scrollbar-hidden">
                {Array(12)
                  .fill()
                  .map(() => (
                    <div className="d-flex m-2 ">
                      <div style={{ width: "65px", height: "40px" }}>
                        <img src={Hero} className="w-100 h-100 rounded" />
                      </div>
                      <div
                        className="d-flex flex-column ms-2 "
                        style={{ width: "100px" }}
                      >
                        <p className="bold mb-0 fs-8">{"Harjis Garden"}</p>
                        <p className="fs-8">{"650m"}</p>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="d-flex  scrollbar-hidden">
                {Array(12)
                  .fill()
                  .map(() => (
                    <div className="d-flex m-2 ">
                      <div style={{ width: "65px", height: "40px" }}>
                        <img src={Hero} className="w-100 h-100 rounded" />
                      </div>
                      <div
                        className="d-flex flex-column ms-2 "
                        style={{ width: "100px" }}
                      >
                        <p className="bold mb-0 fs-8">{"Harjis Garden"}</p>
                        <p className="fs-8">{"650m"}</p>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="d-flex justify-content-center align-item-center">
                <button className="secondary-btn "> Book your Stay </button>
              </div>
            </div>

            <div className="mt-5">
              <div className="top-heading text-capitalize">
                More popular places
              </div>

              <div className="row flex-nowrap scrollbar-hidden p-0 m-0 mt-2">
                {Array(10)
                  .fill()
                  .map(() => (
                    <div className="col-6 p-1">
                      <div
                        className=""
                        style={{ height: "121px", position: "relative" }}
                      >
                        <img
                          src={cardImg}
                          className="w-100 h-100 rounded "
                          alt=""
                          style={{ objectFit: "cover" }}
                        />
                        <div
                          className="w-100 h-100 rounded d-flex justify-content-center align-items-center flex-column"
                          style={{
                            position: "absolute",
                            top: "0",
                            background:
                              "linear-gradient(to left, rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)),linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
                          }}
                        >
                          <p
                            className="mb-0 text-center text-light"
                            style={{ color: "#fffff", fontSize: "24px" }}
                          >
                            Shiva Temple
                          </p>
                          <p className="fs-9 mb-1 text-light">Pokhara, Nepal</p>
                          <div className="text-warning me-2 fs-9 d-flex">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-half"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="row flex-nowrap scrollbar-hidden p-0 m-0 mt-2">
                {Array(10)
                  .fill()
                  .map(() => (
                    <div className="col-6 p-1">
                      <div
                        className=""
                        style={{ height: "121px", position: "relative" }}
                      >
                        <img
                          src={cardImg}
                          className="w-100 h-100 rounded "
                          alt=""
                          style={{ objectFit: "cover" }}
                        />
                        <div
                          className="w-100 h-100 rounded d-flex justify-content-center align-items-center flex-column"
                          style={{
                            position: "absolute",
                            top: "0",
                            background:
                              "linear-gradient(to left, rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)),linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
                          }}
                        >
                          <p
                            className="mb-0 text-center text-light"
                            style={{ color: "#fffff", fontSize: "24px" }}
                          >
                            Shiva Temple
                          </p>
                          <p className="fs-9 mb-1 text-light">Pokhara, Nepal</p>
                          <div className="text-warning me-2 fs-9 d-flex">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-half"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            {/* accummodation */}
            <div className="mt-5">
              <div className="top-heading">Location based Accommodation </div>

              <div className="mt-4 p-0">
                <ul className="list-unstyled d-flex overflow-auto scrollbar-hidden">
                  {Array(10)
                    .fill()
                    .map((location, i) => (
                      <li className="m-2" key={i}>
                        <div
                          className=""
                          style={{ width: "230px", height: "240px" }}
                        >
                          <AccommodationCard />
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="d-flex justify-content-center align-item-center">
              <button className="secondary-btn"> Explore more </button>
            </div>

            {/* offers */}
            <div className="offers mt-4">
              <div className="row mx-0 ">
                <div className="top-heading ">Offers Tailored For You</div>
              </div>

              <div className="row  mx-0 my-3">
                <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard
                        data={"Get upto 15% off on your First Booking"}
                      />
                    </div>
                  </li>

                  <li className="m-2">
                    <div className="bg-dark rounded offers-card-container">
                      <OfferCard data={"Budget Friendly Homestays"} />
                    </div>
                  </li>
                </ul>

                <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
              </div>
              <div className="d-flex justify-content-center align-item-center">
                <button className="secondary-btn "> Explore more </button>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default LocationDeatials;
